<template>
  <header classs="header">
    <div class="header-home" v-if="header === 'landing-page'">
      <div class="decobar"></div>
      <video class="header-video d-none d-md-block" muted autoplay loop
             :poster="require('../assets/images/mustio.jpg')"
             :src="require('../assets/video/visit_raseborg_web_hero_2019 v5_1_opt.mp4')"></video>
      <img class="header-image d-md-none" :src="require('../assets/images/raaseporinlinna-phone.jpg')">
      <RaseborgLogo/>
      <LanguageSelector/>
        <div class="landing-cta mx-4 mx-md-0">
          <h1 class="mb-3">{{ getPage['ctaTitle'] }}</h1>
          <Wave/>
          <p class="font-weight-bold pt-3 d-none d-md-block">{{ getPage['ctaText'] }}</p>
          <router-link class="mt-3 mt-md-0" :to="{ name: 'kone'}">
            <button class="btn" @click="startMachine">{{ $t('general.play') }}</button>
          </router-link>
        </div>
      <div class="map-link">
        <a href="#map" v-smooth-scroll>
          <p class="mb-0">{{ $t('general.where') }}</p>
          <Arrow/>
        </a>
      </div>
    </div>
    <div class="header-kone" v-if="header === 'kone'">
      <div class="decobar"></div>
      <img class="header-image-kone" :src="require('../assets/images/' + currImage +'')">
      <RaseborgLogo/>
      <LanguageSelector/>
      <div class="header-title p-3">
        <h1 class="pt-5 pt-lg-0 text-uppercase">{{ $t(getCurrent + '.title') }}</h1>
      </div>
      <div class="aalto-container">
        <Aalto/>
      </div>
    </div>
    <div class="header-kone header-results" v-if="header === 'results'">
      <div class="decobar"></div>
      <RaseborgLogo/>
      <LanguageSelector/>
      <div class="header-title p-3">
        <h1 v-if="this.winner.length > 0" class="pt-5 pt-lg-0 mt-5 mt-lg-0 mb-4 text-uppercase">{{ $t('results.title') }}</h1>
        <h1 v-else  class="pt-5 pt-lg-0 mt-5 mt-lg-0 mb-4 text-uppercase">{{ $t('results.title-share') }}</h1>
        <p v-if=this.winner.length > 0" class="results-ingress">{{ $t('results.ingress') }}</p>
      </div>
      <div class="aalto-container">
        <Aalto/>
      </div>
    </div>
    <div class="header-kone header-rules" v-if="header === 'rules'">
      <div class="decobar"></div>
      <RaseborgLogo/>
      <language-selector/>
      <div class="header-title p-3">
        <h1 class="pt-5 mt-5 pb-4 pt-lg-0 text-uppercase">{{ getPage['title'] }}</h1>
        <router-link class="mt-3 mt-md-0" :to="{ name: 'home'}">
          <button class="btn">{{ $t('rules.return') }}</button>
        </router-link>
      </div>
      <div class="aalto-container">
        <Aalto />
      </div>
    </div>
  </header>
</template>

<script>
import Wave from '@/assets/svg/wave.svg'
import RaseborgLogo from '@/assets/svg/raseborglogo.svg'
import LanguageSelector from './LanguageSelector'
import Arrow from '@/assets/svg/arrow.svg'
import Aalto from '@/assets/svg/unelmakone-aalto.svg'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Header',
  components: {
    LanguageSelector,
    Wave,
    RaseborgLogo,
    Arrow,
    Aalto
  },
  props: {
    header: String
  },
  computed: {
    ...mapGetters(['getCurrent']),
    ...mapState(['winner']),
    getPage () {
      return this.$store.getters.getPage(this.header)
    },
    currImage () {
      if (this.$store.state.images[this.getCurrent]) {
        return this.$store.state.images[this.getCurrent]
      }
      return ''
    }
  },
  methods: {
    startMachine () {
      this.$store.commit('setPos', 'residence')
    }
  }
}
</script>
